import axios from "axios"

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}, signal = null) {
  if (!options.headers) {
    options.headers = {}
  }

  if (signal) options.signal = signal

  const token = localStorage.getItem("token")

  if (token) {
    options.headers.Authorization = token
  }

  options.headers["Content-Type"] = "application/json"

  return options
}

export default {
  // ... andere objekte ...

  mail: {
    // NEU: Status Abfrage

    async getStatus() {
      return axios.get(buildUrl("mail/status"), buildOptions()).then((r) => r.data)
    },

    async getFolders() {
      return axios.get(buildUrl("mail/folders"), buildOptions()).then((r) => r.data)
    },

    async getMails(params = {}) {
      const query = new URLSearchParams(params).toString()

      return axios.get(buildUrl(`mail/mails?${query}`), buildOptions()).then((r) => r.data)
    },

    async getMailContent(folder, uid) {
      return axios.get(buildUrl(`mail/content?folder=${encodeURIComponent(folder)}&uid=${uid}`), buildOptions()).then((r) => r.data)
    },

    async downloadAttachment(folder, uid, checksum, filename) {
      const options = buildOptions({
        params: { folder, uid, checksum, filename },
        responseType: "blob",
      })
      return axios.get(buildUrl("mail/attachment"), options)
    },

    async createFolder(name) {
      return axios.post(buildUrl("mail/folder"), { name }, buildOptions()).then((r) => r.data)
    },

    async moveMails(uids, fromFolder, toFolder) {
      return axios.post(buildUrl("mail/move"), { uids, fromFolder, toFolder }, buildOptions()).then((r) => r.data)
    },

    async linkCustomer(payload) {
      return axios.post(buildUrl("mail/link-customer"), payload, buildOptions()).then((r) => r.data)
    },

    async assignUser(payload) {
      return axios.post(buildUrl("mail/assign"), payload, buildOptions()).then((r) => r.data)
    },

    async updateFlags(folder, uid, messageId, isRead) {
      return axios
        .post(
          buildUrl("mail/flags"),
          {
            folder,
            uid,
            messageId,
            flags: ["\\Seen"],
            add: isRead,
          },
          buildOptions(),
        )
        .then((r) => r.data)
    },

    async generateDraft(payload) {
      return axios.post(buildUrl("mail/generate-draft"), payload, buildOptions()).then((r) => r.data)
    },

    async send(payload) {
      return axios.post(buildUrl("mail/send"), payload, buildOptions()).then((r) => r.data)
    },

    async update(id, payload) {
      return axios.patch(buildUrl(`mail/${id}`), payload, buildOptions()).then((r) => r.data)
    },

    async manualTacLookup(email) {
      return axios.get(buildUrl(`mail/tac-lookup?email=${encodeURIComponent(email)}`), buildOptions()).then((r) => r.data)
    },

    async regenerate(payload) {
      return axios.post(buildUrl("mail/regenerate"), payload, buildOptions()).then((r) => r.data)
    },
  },

  aiChat: {
    submitTrialLead(payload) {
      return axios.post(buildUrl("ai/submit-trial-lead"), payload, buildOptions()).then((r) => r.data)
    },
    summarizeLead(payload) {
      return axios.post(buildUrl("ai/summarize-lead"), payload, buildOptions()).then((r) => r.data)
    },
    async streamChat(payload, onChunk) {
      const url = buildUrl("ai/chat")
      const options = buildOptions({
        method: "POST",
        body: JSON.stringify(payload),
      })

      const response = await fetch(url, options)

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      // Den Stream lesen
      const reader = response.body.getReader()
      const decoder = new TextDecoder("utf-8")
      let done = false

      while (!done) {
        const { value, done: readerDone } = await reader.read()
        done = readerDone
        if (value) {
          const chunk = decoder.decode(value, { stream: true })
          // Chunk an das UI senden
          onChunk(chunk)
        }
      }
    },
  },

  ai: {
    async fake(payload) {
      const url = buildUrl("ai/fake")

      return axios.post(url, payload, buildOptions()).then((res) => res.data)
    },

    async streamChat(payload, signal) {
      const url = buildUrl("ai/chat")

      const options = buildOptions(
        {
          method: "POST",

          body: JSON.stringify(payload),
        },

        signal,
      )

      return fetch(url, options)
    },
  },
}
